module.exports = __webpack_public_path__ + "img/hc_pro_six_6.ac35f471.jpg";